<template>
  <div class="divBox">

    <el-card class="box-card">
      <el-button size="small" type="primary" @click="batchPriceFn">一键同步</el-button>
      <el-table
        v-loading="listLoading"
        :data="tableData.data"
        style="width: 100%"
        size="small"
        row-key="recovery_category_id"
        :default-expand-all="false"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        <el-table-column
          label="分类名称"
          min-width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.cate_name }}</span>
            <!--            <span>{{ scope.row.cate_name + '  [ ' + scope.row.recovery_category_id + '  ]' }}</span>-->
          </template>
        </el-table-column>
        <el-table-column
          label="回收价格"
          min-width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.level == 3 ? scope.row.recovery_price : '-' }}
            <el-button v-if="scope.row.level==3" @click.stop="showUpdatePriceFn(scope.row)" type="text" size="small"
                       class="mr10">更新价格
            </el-button>
            <el-popconfirm
              hide-icon
              placement="top"
              v-show="scope.row.level==3"
              title="确定同步价格吗？"
              @confirm="synchronousPriceFn(scope.row)"
            >
              <el-button slot="reference" type="text" size="small" class="mr10">同步价格</el-button>
            </el-popconfirm>
            <el-button v-if="scope.row.level==3" @click.stop="showUpdate69Fn(scope.row)" type="text" size="small"
                       class="mr10">设置69码
            </el-button>

          </template>
        </el-table-column>
        <el-table-column
            prop="warehous_code"
            label="69码"
            min-width="50"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.level==3">{{scope.row.warehous_code?scope.row.warehous_code:'暂无'}}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="reware_integral"
            label="甄豆数量"
            min-width="50"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.level==3">{{scope.row.reware_integral?scope.row.reware_integral:'暂无'}}</span>
            <span v-else>-</span>
            <el-button v-if="scope.row.level==3" @click.stop="showUpdatezhenDouFn(scope.row)" type="text" size="small"
                       class="mr10">设置甄豆数量
            </el-button>
          </template>
        </el-table-column>

        <el-table-column
          prop="sort"
          label="排序"
          min-width="50"
        />
        <el-table-column
          prop="create_time"
          label="创建时间"
          min-width="150"
        />
      </el-table>
    </el-card>
    <el-dialog
      title="更新价格"
      :visible.sync="dialogVisible"
      width="30%">
      <el-input placeholder="请输入价格" v-model="updatePrice"></el-input>
      <span slot="footer" class="dialog-footer">
    <el-button @click="cancelUpdateFn">取 消</el-button>
    <el-button type="primary" @click="confirmUpdateFn">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
        title="设置69码"
        :visible.sync="dialog69Visible"
        width="30%">
      <el-input placeholder="请输入69码" v-model="number69"></el-input>
      <span slot="footer" class="dialog-footer">
    <el-button @click="cancel69Fn">取 消</el-button>
    <el-button type="primary" @click="confirm69Fn">确 定</el-button>
  </span>
    </el-dialog>



    <el-dialog
      title="设置甄豆数量"
      :visible.sync="zhendouShow"
      width="30%">
      <el-input placeholder="请输入甄豆数量" v-model="reware_integral"></el-input>
      <span slot="footer" class="dialog-footer">
    <el-button @click="zhendouShow = false">取 消</el-button>
    <el-button type="primary" @click="zhendouConfirmFn">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import {
  recoveryWarehousCodeUpdateApi,
  recoveryCategorySkuUpdateApi,
  recoveryCategorySkuListApi,
  batchPrice,
  integralUpdate
} from "@/api/recovery";
import {roterPre} from "@/settings";

export default {
  name: 'recoveryCategory',
  data() {
    return {
      zhendouShow:false,
      number69:'',//69码
      reware_integral:'',
      recovery_attr_id:0,
      updatePrice: '0',
      dialog69Visible:false,
      dialogVisible: false,
      moren: require("@/assets/images/bjt.png"),
      isChecked: false,
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      roterPre: roterPre,
      tableFrom: {
        page: 1,
        limit: 20
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    /**
     * 一键同步
     * */
     batchPriceFn(){
        this.listLoading = true
        batchPrice().then(res=>{
          console.log(res)
          this.listLoading = false
          this.getList()
        }).catch(err=>{
          this.$message.error(res.message)
          this.listLoading = false
        })
    },
    /**
     * 设置甄豆数量
     * */
    zhendouConfirmFn(){
      let params = {
        recovery_attr_id:this.recovery_attr_id,
        reware_integral:this.reware_integral
      }
      integralUpdate(params).then(res=>{
        this.getList()
      }).catch(err=>{
        this.$message.error(err.message)
      })
      this.recovery_attr_id = 0
      this.reware_integral = ''
      this.zhendouShow = false
    },
    /**
     * 设置甄豆数量 确认弹框
     * */
    showUpdatezhenDouFn(row){
      this.recovery_attr_id = row.recovery_attr_id
      this.zhendouShow = true
    },
    confirm69Fn(){//设置69码
      recoveryWarehousCodeUpdateApi({recovery_attr_id:this.recovery_attr_id,warehous_code:this.number69}).then(res=>{
        this.recovery_attr_id=0
        this.number69=''
        this.getList()
      }).catch(res => {
        this.$message.error(res.message)
      })
      this.dialog69Visible = false
    },
    cancel69Fn(){//取消修改69码
      this.recovery_attr_id=0
      this.number69=''
      this.dialog69Visible = false
    },
    showUpdate69Fn(row){//显示修改69码弹框
      this.dialog69Visible = true
      this.recovery_attr_id=row.recovery_attr_id
    },
    synchronousPriceFn(row){//同步价格
      this.listLoading = true
      recoveryCategorySkuUpdateApi({recovery_attr_id:row.recovery_attr_id,recovery_price:row.recovery_price}).then(res=>{
        this.listLoading =false
        this.getList()
      }).catch(res => {
        this.$message.error(res.message)
        this.listLoading =false
      })
    },
    confirmUpdateFn(){//确定修改价格
      recoveryCategorySkuUpdateApi({recovery_attr_id:this.recovery_attr_id,recovery_price:this.updatePrice}).then(res=>{
        this.recovery_attr_id=0
        this.updatePrice=''
        this.getList()
      }).catch(res => {
        this.$message.error(res.message)
      })
      this.dialogVisible = false

    },
    cancelUpdateFn(){//取消修改价格
      this.recovery_attr_id=0
      this.updatePrice=''
      this.dialogVisible = false
    },
    showUpdatePriceFn(row) {//显示修改弹框
      this.dialogVisible = true
      this.recovery_attr_id=row.recovery_attr_id
    },
    // 列表
    getList() {
      this.listLoading = true
      recoveryCategorySkuListApi(this.tableFrom).then(res => {
        this.tableData.data = res.data
        this.tableData.total = res.data.count
        this.listLoading = false
        this.tableData.data.map((item, index) => {
          item.children.map((item1, index1) => {
            item1.children.map((item2, index2) => {
              item2.recovery_category_id = index + '' + index1 + '' + index2
            })
          })
        })
      }).catch(res => {
        this.listLoading = false
        this.$message.error(res.message)
      })
    },
    pageChange(page) {
      this.tableData.page = page
      this.getList()
    },
    handleSizeChange(val) {
      this.tableData.limit = val
      this.getList()
    },
  }
}
</script>

<style scoped lang="scss">
</style>
